export default [{
	key: "susceptibility",
	name: "Landslide susceptibility",
	opacity: 0.7,
	options: {
		url: "http://37.205.9.25:8080/geoserver/wbmya/wms?",
		params: {
			layers: "wbmya:drr_wbmya_ls-susceptibility"
		}
	},
	type: "wms"
},{
	key: "stationing",
	name: "Stationing (km from the centre of Kale)",
	options: {
		url: "http://37.205.9.25:8080/geoserver/wbmya/wms?",
		params: {
			layers: "wbmya:drr_wbmya_km"
		}
	},
	type: "wms"
},{
	key: "inventory",
	name: "Landslide inventory",
	options: {
		url: "http://37.205.9.25:8080/geoserver/wbmya/wms?",
		params: {
			layers: "wbmya:drr_wbmya_lsinventory"
		}
	},
	type: "wms"
},{
	key: "deformation_clusters",
	name: "Active deformation clusters",
	options: {
		url: "http://37.205.9.25:8080/geoserver/wbmya/wms?",
		params: {
			layers: "wbmya:drr_wbmya_riskzones_ada"
		}
	},
	type: "wms"
}];